<template>
  <div id="app">
    <!-- <mainHeader /> -->
    <ChartGrid />
    <p class="source">
      Dados:
      <a href="https://ourworldindata.org/coronavirus" target="_blank"
        >"Our World in Data - Coronavirus Source Data"</a
      >
    </p>
  </div>
</template>

<script>
// import MainHeader from "./components/header.vue";
import ChartGrid from "./components/charts_grid.vue";

export default {
  name: "App",
  components: {
    // MainHeader,
    ChartGrid,
  },
};
</script>

<style>
.source {
  text-align: center;
  margin-top: 50px;
  font-size: 0.875rem;
  color: #8a8a8a;
}

.source a {
  color: #8a8a8a;
}

#app {
  min-height: 100vh;
}
.row {
  max-width: 72.5rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
}
.row .row {
  margin-right: -0.9375rem;
  margin-left: -0.9375rem;
}
@media print, screen and (min-width: 40em) {
  .row .row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
@media print, screen and (min-width: 64em) {
  .row .row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.row .row.collapse {
  margin-right: 0;
  margin-left: 0;
}
.row.expanded {
  max-width: none;
}
.row.expanded .row {
  margin-right: auto;
  margin-left: auto;
}
.row:not(.expanded) .row {
  max-width: none;
}
.row.collapse > .column,
.row.collapse > .columns {
  padding-right: 0;
  padding-left: 0;
}
.row.is-collapse-child,
.row.collapse > .column > .row,
.row.collapse > .columns > .row {
  margin-right: 0;
  margin-left: 0;
}
.column,
.columns {
  flex: 1 1 0px;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
  min-width: 0;
}
@media print, screen and (min-width: 40em) {
  .column,
  .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.column.row.row,
.row.row.columns {
  float: none;
  display: block;
}
.row .column.row.row,
.row .row.row.columns {
  margin-right: 0;
  margin-left: 0;
  padding-right: 0;
  padding-left: 0;
}
.small-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}
.small-offset-0 {
  margin-left: 0%;
}
.small-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}
.small-offset-1 {
  margin-left: 8.3333333333%;
}
.small-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
.small-offset-2 {
  margin-left: 16.6666666667%;
}
.small-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}
.small-offset-3 {
  margin-left: 25%;
}
.small-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}
.small-offset-4 {
  margin-left: 33.3333333333%;
}
.small-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.small-offset-5 {
  margin-left: 41.6666666667%;
}
.small-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}
.small-offset-6 {
  margin-left: 50%;
}
.small-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}
.small-offset-7 {
  margin-left: 58.3333333333%;
}
.small-9 {
  flex: 0 0 75%;
  max-width: 75%;
}
.small-offset-8 {
  margin-left: 66.6666666667%;
}
.small-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}
.small-offset-9 {
  margin-left: 75%;
}
.small-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}
.small-offset-10 {
  margin-left: 83.3333333333%;
}
.small-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.small-offset-11 {
  margin-left: 91.6666666667%;
}
.small-up-1 {
  flex-wrap: wrap;
}
.small-up-1 > .column,
.small-up-1 > .columns {
  flex: 0 0 100%;
  max-width: 100%;
}
.small-up-2 {
  flex-wrap: wrap;
}
.small-up-2 > .column,
.small-up-2 > .columns {
  flex: 0 0 50%;
  max-width: 50%;
}
.small-up-3 {
  flex-wrap: wrap;
}
.small-up-3 > .column,
.small-up-3 > .columns {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}
.small-up-4 {
  flex-wrap: wrap;
}
.small-up-4 > .column,
.small-up-4 > .columns {
  flex: 0 0 25%;
  max-width: 25%;
}
.small-up-5 {
  flex-wrap: wrap;
}
.small-up-5 > .column,
.small-up-5 > .columns {
  flex: 0 0 20%;
  max-width: 20%;
}
.small-up-6 {
  flex-wrap: wrap;
}
.small-up-6 > .column,
.small-up-6 > .columns {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}
.small-up-7 {
  flex-wrap: wrap;
}
.small-up-7 > .column,
.small-up-7 > .columns {
  flex: 0 0 14.2857142857%;
  max-width: 14.2857142857%;
}
.small-up-8 {
  flex-wrap: wrap;
}
.small-up-8 > .column,
.small-up-8 > .columns {
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.small-collapse > .column,
.small-collapse > .columns {
  padding-right: 0;
  padding-left: 0;
}
.small-uncollapse > .column,
.small-uncollapse > .columns {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
@media print, screen and (min-width: 40em) {
  .medium-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .medium-offset-0 {
    margin-left: 0%;
  }
  .medium-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .medium-offset-1 {
    margin-left: 8.3333333333%;
  }
  .medium-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .medium-offset-2 {
    margin-left: 16.6666666667%;
  }
  .medium-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .medium-offset-3 {
    margin-left: 25%;
  }
  .medium-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .medium-offset-4 {
    margin-left: 33.3333333333%;
  }
  .medium-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .medium-offset-5 {
    margin-left: 41.6666666667%;
  }
  .medium-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .medium-offset-6 {
    margin-left: 50%;
  }
  .medium-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .medium-offset-7 {
    margin-left: 58.3333333333%;
  }
  .medium-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .medium-offset-8 {
    margin-left: 66.6666666667%;
  }
  .medium-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .medium-offset-9 {
    margin-left: 75%;
  }
  .medium-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .medium-offset-10 {
    margin-left: 83.3333333333%;
  }
  .medium-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .medium-offset-11 {
    margin-left: 91.6666666667%;
  }
  .medium-up-1 {
    flex-wrap: wrap;
  }
  .medium-up-1 > .column,
  .medium-up-1 > .columns {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .medium-up-2 {
    flex-wrap: wrap;
  }
  .medium-up-2 > .column,
  .medium-up-2 > .columns {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .medium-up-3 {
    flex-wrap: wrap;
  }
  .medium-up-3 > .column,
  .medium-up-3 > .columns {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .medium-up-4 {
    flex-wrap: wrap;
  }
  .medium-up-4 > .column,
  .medium-up-4 > .columns {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .medium-up-5 {
    flex-wrap: wrap;
  }
  .medium-up-5 > .column,
  .medium-up-5 > .columns {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .medium-up-6 {
    flex-wrap: wrap;
  }
  .medium-up-6 > .column,
  .medium-up-6 > .columns {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .medium-up-7 {
    flex-wrap: wrap;
  }
  .medium-up-7 > .column,
  .medium-up-7 > .columns {
    flex: 0 0 14.2857142857%;
    max-width: 14.2857142857%;
  }
  .medium-up-8 {
    flex-wrap: wrap;
  }
  .medium-up-8 > .column,
  .medium-up-8 > .columns {
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
}
@media print, screen and (min-width: 40em) and (min-width: 40em) {
  .medium-expand {
    flex: 1 1 0px;
  }
}
.row.medium-unstack > .column,
.row.medium-unstack > .columns {
  flex: 0 0 100%;
}
@media print, screen and (min-width: 40em) and (min-width: 40em) {
  .row.medium-unstack > .column,
  .row.medium-unstack > .columns {
    flex: 1 1 0px;
  }
}
@media print, screen and (min-width: 40em) {
  .medium-collapse > .column,
  .medium-collapse > .columns {
    padding-right: 0;
    padding-left: 0;
  }
  .medium-uncollapse > .column,
  .medium-uncollapse > .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 64em) {
  .large-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .large-offset-0 {
    margin-left: 0%;
  }
  .large-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .large-offset-1 {
    margin-left: 8.3333333333%;
  }
  .large-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .large-offset-2 {
    margin-left: 16.6666666667%;
  }
  .large-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .large-offset-3 {
    margin-left: 25%;
  }
  .large-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .large-offset-4 {
    margin-left: 33.3333333333%;
  }
  .large-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .large-offset-5 {
    margin-left: 41.6666666667%;
  }
  .large-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .large-offset-6 {
    margin-left: 50%;
  }
  .large-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .large-offset-7 {
    margin-left: 58.3333333333%;
  }
  .large-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .large-offset-8 {
    margin-left: 66.6666666667%;
  }
  .large-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .large-offset-9 {
    margin-left: 75%;
  }
  .large-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .large-offset-10 {
    margin-left: 83.3333333333%;
  }
  .large-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .large-offset-11 {
    margin-left: 91.6666666667%;
  }
  .large-up-1 {
    flex-wrap: wrap;
  }
  .large-up-1 > .column,
  .large-up-1 > .columns {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .large-up-2 {
    flex-wrap: wrap;
  }
  .large-up-2 > .column,
  .large-up-2 > .columns {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .large-up-3 {
    flex-wrap: wrap;
  }
  .large-up-3 > .column,
  .large-up-3 > .columns {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .large-up-4 {
    flex-wrap: wrap;
  }
  .large-up-4 > .column,
  .large-up-4 > .columns {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .large-up-5 {
    flex-wrap: wrap;
  }
  .large-up-5 > .column,
  .large-up-5 > .columns {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .large-up-6 {
    flex-wrap: wrap;
  }
  .large-up-6 > .column,
  .large-up-6 > .columns {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .large-up-7 {
    flex-wrap: wrap;
  }
  .large-up-7 > .column,
  .large-up-7 > .columns {
    flex: 0 0 14.2857142857%;
    max-width: 14.2857142857%;
  }
  .large-up-8 {
    flex-wrap: wrap;
  }
  .large-up-8 > .column,
  .large-up-8 > .columns {
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
}
@media print, screen and (min-width: 64em) and (min-width: 64em) {
  .large-expand {
    flex: 1 1 0px;
  }
}
.row.large-unstack > .column,
.row.large-unstack > .columns {
  flex: 0 0 100%;
}
@media print, screen and (min-width: 64em) and (min-width: 64em) {
  .row.large-unstack > .column,
  .row.large-unstack > .columns {
    flex: 1 1 0px;
  }
}
@media print, screen and (min-width: 64em) {
  .large-collapse > .column,
  .large-collapse > .columns {
    padding-right: 0;
    padding-left: 0;
  }
  .large-uncollapse > .column,
  .large-uncollapse > .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.shrink {
  flex: 0 0 auto;
  max-width: 100%;
}
.column-block {
  margin-bottom: 1.875rem;
}
.column-block > :last-child {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .column-block {
    margin-bottom: 1.875rem;
  }
  .column-block > :last-child {
    margin-bottom: 0;
  }
}
@-webkit-keyframes mapboxgl-user-location-dot-pulse {
  0% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(3);
    opacity: 0;
  }
  to {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
body {
  background: #fff;
}
#subscriptions-promo-01 {
  display: none !important;
}
@media print, screen and (min-width: 40em) {
  /* .social-tools__item--whatsapp {
    display: block !important;
  } */
}
.is-loading::before {
  background: rgba(255, 255, 255, 0.7);
}
.show-for-touch,
.hide-for-touch {
  display: none;
}
html.no-touch .hide-for-touch {
  display: inline;
}
html:not(.no-touch) .show-for-touch {
  display: inline;
}
.content,
#page {
  overflow: visible;
  background: #fff;
}
.page__header .kicker:not(.kicker--exclusive):not(.kicker--label) {
  height: 32px;
  display: block;
  margin-bottom: 0.75rem;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  display: block;
  overflow: hidden;
  text-indent: -9999px;
}
.page__header .kicker:not(.kicker--exclusive):not(.kicker--label)::before {
  content: "";
  background: url("data:image/png;base64,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");
  background-size: 100% 100%;
  position: relative;
  opacity: 0.8;
  height: 32px;
  width: 166px;
  display: block;
  z-index: 2;
  margin-left: auto;
  margin-right: auto;
  visibility: visible;
  position: relative;
  text-indent: 0;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.15s ease-in-out;
}
@media screen and (max-width: 39.99875em) {
  .page__header .kicker:not(.kicker--exclusive):not(.kicker--label) {
    height: 24px;
  }
  .page__header .kicker:not(.kicker--exclusive):not(.kicker--label)::before {
    height: 24px;
    width: 125px;
    background-position: 0 0;
  }
}
.page__header
  .kicker:not(.kicker--exclusive):not(.kicker--label):hover::before {
  opacity: 0.7;
}
.page__header .kicker:not(.kicker--exclusive):not(.kicker--label) a {
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  border: none;
}
.page__body {
  padding-bottom: 4rem;
}
.page__meta {
  margin-bottom: 4px;
}
.is-webview .page__header {
  padding: 32px 0 0;
}
.page__header > .social-tools {
  display: none;
}
.page__header .byline {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .page__header .byline {
    display: inline;
  }
}
@media print, screen and (min-width: 40em) {
  .page__header .dateline:not(.show-for-sr):before {
    content: "\2022";
    display: inline-block;
    font-size: 8px;
    vertical-align: middle;
    margin: 0 0.25rem;
  }
}
.page__title__wrapper,
.page__meta,
.page__blurb,
.social-tools {
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
  text-align: center;
}
@media print, screen and (min-width: 40em) {
  .page__title__wrapper,
  .page__meta,
  .page__blurb,
  .social-tools {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 64em) {
  .page__title__wrapper {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 64em) and (min-width: 40em) {
  .page__title__wrapper {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.page__title .kicker {
  display: block;
  margin-bottom: 0.5rem;
}
.social-tools {
  margin-top: 0.5rem;
}
.social-tools ul {
  justify-content: center;
}
.social-tools ul li a {
  background: #e2e2e2 !important;
  color: #222;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
}
.social-tools ul li a:hover {
  background: #cacaca !important;
}
.page__header__wrapper {
  max-width: 72.5rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: 100%;
  padding-bottom: 2rem;
  padding-top: 2rem;
  margin-bottom: 2rem;
}
.page__header__wrapper::after {
  content: "";
  display: block;
  position: absolute;
  height: 1px;
  left: 15px;
  right: 15px;
  background: #efefef;
  bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .page__header__wrapper::after {
    left: 15px;
    right: 15px;
  }
}
@media print, screen and (min-width: 64em) {
  .page__header__wrapper {
    position: relative;
  }
  .page__header__wrapper::after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    left: 15px;
    right: 15px;
    background: #efefef;
    bottom: 0;
  }
}
@media print, screen and (min-width: 64em) and (min-width: 40em) {
  .page__header__wrapper::after {
    left: 15px;
    right: 15px;
  }
}
@media print, screen and (min-width: 64em) {
  .page__header__wrapper::after {
    left: calc(8.333333335% + 0.9375rem) !important;
    right: calc(8.333333335% + 0.9375rem) !important;
  }
}
.page__title {
  font-family: Times, "Times New Roman", serif;
  letter-spacing: 0;
  font-weight: 700;
  text-transform: none;
  font-size: 32px;
  line-height: 36px;
  margin-bottom: 4px;
}
.fonts-a-loaded .page__title {
  font-family: "publico-bold", Times, "Times New Roman", serif;
  font-style: normal;
}
.fonts-b-loaded .page__title i,
.fonts-b-loaded .page__title em {
  font-family: "publico-bold-italic", Times, "Times New Roman", serif;
  font-style: italic;
}
@media print, screen and (min-width: 64em) {
  .page__title {
    font-size: 44px;
    line-height: 46px;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 8px;
  }
  .page__title .kicker {
    font-size: 16px;
    line-height: 20px;
  }
}
.page__header__wrapper {
  justify-content: center;
}
.byline__author a {
  color: #777;
}
.page__blurb {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
  line-height: 22px;
  font-family: Times, "Times New Roman", serif;
  font-weight: 700;
}
.fonts-a-loaded .page__blurb {
  font-family: "publico-medium", Times, "Times New Roman", serif;
  font-style: normal;
}
.fonts-b-loaded .page__blurb i,
.fonts-b-loaded .page__blurb em {
  font-family: "publico-medium-italic", Times, "Times New Roman", serif;
  font-style: italic;
}
@media print, screen and (min-width: 40em) {
  .page__blurb {
    flex: 0 0 70.8333333333%;
    max-width: 70.8333333333%;
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 40em) and (min-width: 40em) {
  .page__blurb {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 40em) {
  .page__blurb {
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 0;
    line-height: 26px;
  }
}
@media print, screen and (min-width: 64em) {
  .page__blurb {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 64em) and (min-width: 40em) {
  .page__blurb {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.page__blurb a {
  color: #555;
  text-decoration: none;
  text-shadow: 0.03em 0 #fff, -0.03em 0 #fff, 0 0.03em #fff, 0 -0.03em #fff,
    0.06em 0 #fff, -0.06em 0 #fff, 0.09em 0 #fff, -0.09em 0 #fff, 0.12em 0 #fff,
    -0.12em 0 #fff, 0.15em 0 #fff, -0.15em 0 #fff;
  background-image: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff),
    linear-gradient(#b90017, #b90017);
  background-size: 0.05em 1.5px, 0.05em 1.5px, 1px 1.5px;
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position: 0% 97%, 100% 97%, 0% 97%;
}
.page__blurb a::-moz-selection {
  text-shadow: 0.03em 0 #fae5e8, -0.03em 0 #fae5e8, 0 0.03em #fae5e8,
    0 -0.03em #fae5e8, 0.06em 0 #fae5e8, -0.06em 0 #fae5e8, 0.09em 0 #fae5e8,
    -0.09em 0 #fae5e8, 0.12em 0 #fae5e8, -0.12em 0 #fae5e8, 0.15em 0 #fae5e8,
    -0.15em 0 #fae5e8;
  background-color: #fae5e8;
}
.page__blurb a::selection {
  text-shadow: 0.03em 0 #fae5e8, -0.03em 0 #fae5e8, 0 0.03em #fae5e8,
    0 -0.03em #fae5e8, 0.06em 0 #fae5e8, -0.06em 0 #fae5e8, 0.09em 0 #fae5e8,
    -0.09em 0 #fae5e8, 0.12em 0 #fae5e8, -0.12em 0 #fae5e8, 0.15em 0 #fae5e8,
    -0.15em 0 #fae5e8;
  background-color: #fae5e8;
}
.page__blurb a::-moz-selection {
  text-shadow: 0.03em 0 #fae5e8, -0.03em 0 #fae5e8, 0 0.03em #fae5e8,
    0 -0.03em #fae5e8, 0.06em 0 #fae5e8, -0.06em 0 #fae5e8, 0.09em 0 #fae5e8,
    -0.09em 0 #fae5e8, 0.12em 0 #fae5e8, -0.12em 0 #fae5e8, 0.15em 0 #fae5e8,
    -0.15em 0 #fae5e8;
  background-color: #fae5e8;
}
.page__blurb a:before,
.page__blurb a:after,
.page__blurb a *,
.page__blurb a *:before,
.page__blurb a *:after {
  text-shadow: none;
}
.page__blurb a:visited {
  color: #555;
}
.page__blurb a:hover {
  color: #000;
}
.page__blurb > p {
  font-style: inherit;
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  margin-bottom: 16px;
  color: #555;
}
.page__body {
  position: relative;
}
.page__body::after {
  content: "";
  display: block;
  position: absolute;
  height: 1px;
  left: 15px;
  right: 15px;
  background: #efefef;
  bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .page__body::after {
    left: 15px;
    right: 15px;
  }
}
@media print, screen and (min-width: 64em) {
  .page__body {
    position: relative;
  }
  .page__body::after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    left: 15px;
    right: 15px;
    background: #efefef;
    bottom: 0;
    max-width: 83.33333333%;
  }
}
@media print, screen and (min-width: 64em) and (min-width: 40em) {
  .page__body::after {
    left: 15px;
    right: 15px;
  }
}
@media print, screen and (min-width: 64em) {
  .page__body::after {
    left: 8.333333335% !important;
    right: 8.333333335% !important;
  }
}
.row--center {
  justify-content: center;
}
.row--center p {
  font-size: 1.125rem;
  line-height: 1.5;
}
.row--center p a {
  color: #860011;
  background: transparent;
  text-decoration: none;
  text-decoration: underline;
}
.row--center p a:hover {
  color: #b90017;
}
.map-wrapper {
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
  position: relative;
}
@media print, screen and (min-width: 40em) {
  .map-wrapper {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
@media print, screen and (min-width: 64em) {
  .map-wrapper {
    overflow: hidden;
  }
}
@media screen and (max-width: 63.99875em) {
  .map-wrapper {
    padding: 0 !important;
  }
}
#map {
  height: 620px;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
}
.main > .stack {
  background: #f7f7f7;
  margin-top: -3rem;
  position: relative;
  z-index: 100;
  padding-bottom: 1rem;
}
.main > .stack .stack__actions {
  display: none;
}
.mapboxgl-canvas {
  cursor: pointer !important;
}
.map-overlay {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  overflow: auto;
  border-radius: 3px;
  z-index: 20;
}
#features {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: 0;
  border: none;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: none;
  overflow: hidden;
  color: #0a0a0a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.2);
  top: 0.9375rem;
  margin-left: 0.9375rem;
  width: 280px;
}
#features > :last-child {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40em) {
  .is-visible #features {
    position: fixed;
    top: 4.5625rem;
    left: auto;
  }
  .is-scrolled-past #features {
    position: absolute;
    top: auto;
    bottom: 0.9375rem;
  }
}
@media screen and (max-width: 63.99875em) {
  #features {
    position: -webkit-sticky;
    position: sticky;
    margin: 0;
    left: 0;
    right: 0;
    width: auto;
    top: 60px;
    border-radius: 0;
    min-height: 133px;
    overflow: hidden;
  }
  .is-webview #features {
    top: 0;
  }
  #features #pd > p {
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
  }
}
#pd {
  padding: 1rem;
}
#pd .kicker {
  display: block;
  margin-bottom: 0.25rem;
}
#pd h3 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 700;
  font-weight: 700;
  text-transform: uppercase;
  color: #777;
  font-size: 1.75rem;
  line-height: 0.88;
  margin-bottom: 1.15rem;
  text-align: center;
  margin-right: 0;
}
.fonts-a-loaded #pd h3 {
  font-family: "giorgiosans-medium", Helvetica, Arial, sans-serif;
}
.fonts-b-loaded #pd h3 i,
.fonts-b-loaded #pd h3 em {
  font-family: "giorgiosans-medium-italic", Helvetica, Arial, sans-serif;
  font-style: italic;
}
@media screen and (max-width: 63.99875em) {
  #pd h3 {
    margin-bottom: 1rem;
  }
}
#pd h3.alt {
  margin-bottom: 0 !important;
}
#label.kicker {
  color: #f58220;
}
.kicker-school {
  color: #009fdf;
  text-align: center;
}
#pd p {
  line-height: 1.45;
  font-size: 13px;
  font-weight: bold;
  color: #999;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 0;
  padding: 0.5rem 0;
}
@media screen and (max-width: 63.99875em) {
  #pd p {
    padding: 0;
  }
}
#infected p {
  padding: 0;
}
#label {
  text-align: center;
}
#infected {
  text-align: center;
}
#infected .number_infect {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 700;
  font-weight: 700;
  text-transform: uppercase;
  color: #000;
  font-size: 2rem !important;
  line-height: 1rem;
  margin-bottom: 0.25rem;
  text-align: center;
  margin-right: 0;
}
.fonts-a-loaded #infected .number_infect {
  font-family: "giorgiosans-medium", Helvetica, Arial, sans-serif;
}
.fonts-b-loaded #infected .number_infect i,
.fonts-b-loaded #infected .number_infect em {
  font-family: "giorgiosans-medium-italic", Helvetica, Arial, sans-serif;
  font-style: italic;
}
#infected .description {
  line-height: 1.125rem;
  font-size: 0.75rem;
  text-align: center;
  font-weight: bold;
  color: #000;
  margin-top: 0.5rem;
  display: block;
}
@media screen and (max-width: 63.99875em) {
  #infected .description {
    margin-bottom: 0.5rem;
  }
}
#infected .error-margin {
  font-size: 0.65rem !important;
  padding: 0;
  margin: 0;
}
#infected .error-margin span {
  font-weight: normal;
}
#controler {
  margin-bottom: 2rem;
}
.geolocation-controler {
  margin-bottom: 1rem;
}
.geolocation-controler .button {
  background-color: #333;
  color: #fff;
}
.geolocation-controler .button:hover,
.geolocation-controler .button:focus {
  background-color: #292929;
  color: #fff;
}
.page--interactive .mapboxgl-ctrl-group:not(:empty) {
  box-shadow: none;
  border: 1px solid #333;
  background: #333;
  color: #fff;
  border-radius: 2px;
}
.page--interactive .mapboxgl-ctrl-group button {
  border-radius: 0;
  border-color: #777;
}
.page--interactive
  .mapboxgl-ctrl
  button.mapboxgl-ctrl-zoom-in
  .mapboxgl-ctrl-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='%23fff'%3E%3Cpath d='M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5z'/%3E%3C/svg%3E");
}
.page--interactive
  .mapboxgl-ctrl
  button.mapboxgl-ctrl-zoom-out
  .mapboxgl-ctrl-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='29' height='29' viewBox='0 0 29 29' xmlns='http://www.w3.org/2000/svg' fill='%23fff'%3E%3Cpath d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-9z'/%3E%3C/svg%3E");
}
.page--interactive .mapboxgl-ctrl button.mapboxgl-ctrl-compass {
  display: none;
}
.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
  margin-right: 1rem !important;
  margin-top: 1rem !important;
}
.mapbox-improve-map {
  display: none !important;
}
#geolocate {
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-bottom: 0;
}
.current-location {
  display: none;
  margin-bottom: 0px;
  min-height: 34px;
  padding-top: 16px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75rem;
  line-height: 1;
  color: #999;
}
.current-location img {
  height: 24px !important;
  width: 24px !important;
  display: inline-block;
  margin-right: 2px;
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  vertical-align: middle;
}
.current-location.message-alert {
  color: #721c24;
}
#target_pulse .lazy-loading {
  min-height: 34px;
  height: 34px;
  line-height: 34px;
}
#target_pulse .lazy-loading::after {
  display: inline-block;
  content: "A obter localização...";
  line-height: 34px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75rem;
  color: #999;
}
#target_pulse .lazy-loading__loader {
  margin: 0px 8px 0 0;
  height: 24px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
}
#target_pulse .lazy-loading__loader::after {
  margin: 0;
  position: static;
}
.marker {
  background-image: url("https://static.publicocdn.com/files/concelhos-covid-viz/img/mapbox-icon.png");
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.marker-top {
  height: 40px;
}
.chart--legend-map {
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto, Oxygen,
    Ubuntu, Cantarell, open sans, helvetica neue, sans-serif;
  margin-left: auto;
  margin-right: auto;
  padding-top: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75rem;
  line-height: 20px;
  color: #8a8a8a;
  opacity: 0.7;
}
.chart--legend-map > div {
  max-width: none;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
}
.chart--legend-map > div div {
  flex: 1 1 0px;
}
.chart--legend-map > div div:first-child {
  text-align: right;
  width: 110px;
}
.chart--legend-map > div .chart--legend--scale {
  flex: 0 0 auto;
}
.chart--legend-map .chart--legend--scale-b > div,
.chart--legend-map img {
  width: 240px !important;
  height: 16px;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
@media screen and (max-width: 63.99875em) {
  .chart--legend-map .chart--legend--scale-b > div,
  .chart--legend-map img {
    width: 120px !important;
  }
}
@media screen and (max-width: 39.99875em) {
  .chart--legend-map .chart--legend--scale-b > div,
  .chart--legend-map img {
    width: 48px !important;
  }
}
.chart--legend-map .chart--legend--scale-b div {
  background-image: linear-gradient(45deg, #e2e2e2 25%, transparent 25%),
    linear-gradient(-45deg, #e2e2e2 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #e2e2e2 75%),
    linear-gradient(-45deg, transparent 75%, #e2e2e2 75%);
  background-size: 8px 8px;
  background-position: 0 0, 0 4px, 4px -4px, -4px 0px;
  position: relative;
}
.chart--legend-map .chart--legend--scale-b div::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(286deg, #000 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 2;
}
#search {
  text-align: center;
}
@media print, screen and (min-width: 64em) {
  #search {
    order: 1;
    text-align: right;
  }
}
.twitter-typeahead {
  display: block;
  width: 100%;
}
@media print, screen and (min-width: 64em) {
  .geolocation-controler {
    order: 2;
    text-align: right;
  }
}
.tt-menu {
  border-radius: 2px;
  text-align: left;
  width: 100%;
  margin-top: -0.875rem;
}
#warning {
  box-shadow: none;
  padding: 1.5rem;
  color: #856404;
  background-color: #fff3cd;
  border-radius: 0;
  text-align: left;
  display: block;
}
#warning p {
  font-size: 0.8125rem;
  line-height: 1.125rem;
  margin-bottom: 1rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
#warning ul,
#warning ol {
  margin-bottom: 0;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
#warning li {
  font-size: 0.8125rem;
  line-height: 1.125rem;
}
#warning li:not(:last-child) {
  margin-bottom: 0.5rem;
}
#warning p:last-child {
  margin-bottom: 0rem;
}
#body--text {
  font-size: 1.125rem;
  color: #111;
  line-height: 1.64;
  margin-bottom: 2rem;
  font-family: Georgia, "Times New Roman", serif;
  margin-top: 4rem;
}
@media screen and (max-width: 63.99875em) {
  #body--text {
    margin-top: 2rem;
  }
}
#headline-chart {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 700;
  font-weight: 700;
  text-transform: uppercase;
  color: #111;
  font-size: 2rem;
  line-height: 0.88;
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  margin-right: 0;
}
.fonts-a-loaded #headline-chart {
  font-family: "giorgiosans-medium", Helvetica, Arial, sans-serif;
}
.fonts-b-loaded #headline-chart i,
.fonts-b-loaded #headline-chart em {
  font-family: "giorgiosans-medium-italic", Helvetica, Arial, sans-serif;
  font-style: italic;
}
.mapstitles {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 700;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: #777;
  font-size: 1.5rem;
  line-height: 0.88;
  margin-top: 0rem;
  margin-bottom: 0.5rem;
  text-align: center;
  margin-right: 0;
}
.fonts-a-loaded .mapstitles {
  font-family: "giorgiosans-medium", Helvetica, Arial, sans-serif;
}
.fonts-b-loaded .mapstitles i,
.fonts-b-loaded .mapstitles em {
  font-family: "giorgiosans-medium-italic", Helvetica, Arial, sans-serif;
  font-style: italic;
}
@media screen and (max-width: 63.99875em) {
  .mapstitles {
    font-size: 20px;
  }
}
.chart-maps {
  margin-bottom: 3rem;
}
.sub-heading--text {
  font-family: Times, "Times New Roman", serif;
  font-weight: 700;
  margin-bottom: 0.5rem;
  font-size: 1.375rem;
  line-height: 1.625rem;
}
.fonts-a-loaded .sub-heading--text {
  font-family: "publico-medium", Times, "Times New Roman", serif;
  font-style: normal;
}
.fonts-b-loaded .sub-heading--text i,
.fonts-b-loaded .sub-heading--text em {
  font-family: "publico-medium-italic", Times, "Times New Roman", serif;
  font-style: italic;
}
@media print, screen and (min-width: 64em) {
  .sub-heading--text {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}
#metodologia h4 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #444;
  font-size: 1rem;
  line-height: 1.375rem;
  text-transform: uppercase;
}
#metodologia p {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #666;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-bottom: 1rem;
}
#metodologia p a {
  text-decoration: underline;
  border-bottom: 0 !important;
  box-shadow: none;
}
#metodologia p a::before {
  display: none;
}
ul.nav {
  margin-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.table-legend {
  margin-top: 0.5rem;
  margin-bottom: 0 !important;
  overflow: hidden;
  float: right;
  margin-right: -16px;
}
.table-legend > li {
  font-size: 11px;
  line-height: 18px;
  color: #777;
  float: left;
  margin-right: 16px;
}
.table-legend-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  position: relative;
  top: -1px;
  background-size: auto 100%;
  background-repeat: no-repeat;
  border-radius: 999px;
}
.table-legend-icon-a {
  width: 16px;
  background-color: #009fdf;
}
.table-legend-icon-b {
  width: 16px;
  background-color: #f58220;
}
</style>
